import React from 'react';
import { useState, useEffect } from 'react';
import { db } from '../data/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { Document, Page, View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import { course_images } from '../utils/images';

// Define styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF', // Background color of the page
  },
  contentContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1, // Ensure the background image is behind other elements
  },
 
  content: {
    width: "80%",
    backgroundColor: 'white',
    padding: 40,
    borderRadius: 10,
    alignItems: 'center',
    textAlign: 'center',
    border: '2px solid #E0E0E0',
  },
  name: {
    fontSize: 36,
    fontWeight: 'bold',
    color: '#2c3e50',
    marginBottom: 8,
    fontFamily: 'Times-Roman',
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  organization: {
    fontSize: 20,
    color: '#34495e',
    marginBottom: 25,
    fontStyle: 'italic',
  },
  text: {
    fontSize: 18,
    color: '#4A4A4A',
    marginBottom: 15,
    fontFamily: 'Helvetica',
    lineHeight: 1.4,
  },
  courseName: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#1a237e',
    marginTop: 10,
    marginBottom: 30,
    padding: 10,
    borderBottom: '2px solid #1a237e',
    width: "auto",
  },
  dateText: {
    fontSize: 16,
    color: '#666666',
    marginTop: 20,
    fontStyle: 'italic',
  }
  
});

const CertificatePDF = ({ name, collegeName, certificateDate }) => {
  const [obj, setObj] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    organization: '',
  });

  useEffect(() => {
    // Retrieve data from localStorage when the component mounts
    const retrievedObj = JSON.parse(localStorage.getItem('person'));
    if (retrievedObj) {
      setObj(retrievedObj);
    }

    // Fetch user's profile data from the database
    const fetchData = async () => {
      try {
        const docRef = doc(db, 'Users', `${obj.email}`); // Update 'userDocumentId' with the actual document ID
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const userProfileData = docSnap.data();
          setFormData(userProfileData);
          console.log('Profile data fetched:', userProfileData);
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Error fetching document: ', error);
      }
    };
    
    if (obj.email) {
      fetchData();
    }
  }, [obj.email]);

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Content */}
        <View style={styles.contentContainer}>
          {/* Background image */}
          <Image src={course_images.coursebg} style={styles.backgroundImage} />

          <View style={styles.content}>
                <Text style={styles.name}>{formData.name}</Text>
                <Text style={styles.organization}>of {formData.organization}</Text>
                <Text style={styles.text}>for the successful completion of the course</Text>
                <Text style={styles.courseName}>{name}</Text>
                <Text style={styles.dateText}>Dated: {certificateDate}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default CertificatePDF;
